import React, { Component } from "react";

import Axios from "axios";

import Search from "./components/Search";
import Filters from "./components/Filters";
import Results from "./components/Results";
import Message from "./components/Message";

import update from "immutability-helper";

const elementary = require("../../vendor/elementary.js");
const _ = require("lodash");
const deepCopy = require("deepcopy");

const perPage = 20;

class ResourceSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryId: this.props.categoryId,
      categoryName: this.props.categoryName,
      filters: [],
      chosenIds: [],
      selectedId: null,
      resources: [],
      filteredResources: [],
      pageCount: null,
      currPage: 1,
      searchTerm: null
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.filterResources = this.filterResources.bind(this);
  }
  componentWillMount() {
    // Load filter categories
    Axios.get("/data/technical-support/categories/subcategories", {
      params: {
        categoryID: this.state.categoryId
      }
    }).then(res => {
      this.setState({ filters: res.data });
    });

    // Load resources
    Axios.get("/data/technical-support/documents", {
      params: {
        category: this.props.categoryName
      }
    }).then(res => {

      var d = res.data;
      d.sort(function(a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }

        return 0;
      })

      this.setState({
        resources: d,
        filteredResources: d,
        pageCount: Math.ceil(d.length / perPage)
      });
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.filters !== prevState.filters ||
      this.state.searchTerm !== prevState.searchTerm
    ) {
      this.filterResources();
    }

    elementary();
  }
  filterResources() {
    // Get copy of resources
    var filtered = deepCopy(this.state.resources);

    // If a category has been selected, filter by chosen category id
    if (this.state.selectedId) {
      filtered = filtered.filter(
        resource => parseInt(resource.categoryId) === this.state.selectedId
      );
    }

    // If there is a current search term, also filter by this
    if (this.state.searchTerm && this.state.searchTerm.length > 0) {
      filtered = filtered.filter(
        resource =>
          resource.name
            .toLowerCase()
            .indexOf(this.state.searchTerm.toLowerCase()) !== -1
      );
    }

    // Amend filtered resources
    this.setState({
      filteredResources: filtered,
      pageCount: Math.ceil(filtered.length / perPage),
      currPage: 1
    });
  }
  handleFilterChange(id, stepNumber) {
    var currFilters = deepCopy(this.state.filters);
    var stepIndex = _.findKey(currFilters, { number: stepNumber });
    var step = currFilters[stepIndex];

    step.chosenId = id;
    currFilters[stepIndex] = step;

    var newChosenIds = deepCopy(this.state.chosenIds);
    newChosenIds[stepNumber] = id;

    if (stepNumber == 1) {
      newChosenIds.splice(2);
      stepIndex = _.findKey(currFilters, { number: 2 });
      step = currFilters[stepIndex];
      step.chosenId = null;
      currFilters[stepIndex] = step;
    }

    this.setState({
      filters: currFilters,
      selectedId: parseInt(id),
      chosenIds: newChosenIds
    });
  }
  handleSearch(term) {
    this.setState({
      searchTerm: term
    });
  }
  handlePageClick(pageNum) {
    this.setState({ currPage: pageNum });
  }
  render() {
    var items = <Message />;

    if (this.state.filteredResources.length > 0) {
      
      items = (
        <Results
          items={this.state.filteredResources}
          pageCount={this.state.pageCount}
          page={this.state.currPage}
          perPage={perPage}
          onPageClick={this.handlePageClick}
        />
      );
    }

    return (
      <div>
        <div className="strip">
          <div className="wrapper">
            <h1 className="heading heading--primary heading--brand content__heading">
              <span>{this.state.categoryName}</span>
            </h1>


            <div className="resource-selector elementary">
              <div className="resource-selector__controls">
                <div className="resource-selector__search">
                  <Search onSearch={this.handleSearch} />
                </div>

                <div className="resource-selector__filters">
                  <Filters
                    items={this.state.filters}
                    chosenIds={this.state.chosenIds}
                    onFilterChange={this.handleFilterChange}
                  />
                </div>
              </div>
            </div>


						{this.state.categoryName === 'Brochures' ? <p>To request a physical brochure, please <a href="/contact-us">Contact us</a></p> : ''}
						
          </div>
        </div>

        <div className="strip strip--alt">
          <div className="wrapper">{items}</div>
        </div>
      </div>
    );
  }
}

export default ResourceSelector;
